module.exports = {
  "country": "DE",
  "artist": "Joy Fleming",
  "song": "Ein Lied kann eine Brücke sein",
  "year": "1975",
  "place": "17",
  "spotify": "68yLDTNBd1PZMl67k6fbY5"
};